import { useId, type TextareaHTMLAttributes } from 'react';
import { FormError } from './FormError';
import './ui.css';

interface TextAreaProps extends Omit<TextareaHTMLAttributes<HTMLTextAreaElement>, 'id'> {
  label: string;
  error?: string | null;
  hint?: string;
}

export function TextArea({ label, error, hint, className, rows = 4, ...rest }: TextAreaProps) {
  const generatedId = useId();
  const errorId = `${generatedId}-error`;
  const hintId = `${generatedId}-hint`;
  const describedBy = [error ? errorId : '', hint ? hintId : ''].filter(Boolean).join(' ');

  return (
    <div className="ui-field">
      <label className="ui-field__label" htmlFor={generatedId}>
        {label}
      </label>
      <textarea
        id={generatedId}
        rows={rows}
        className={[
          'ui-field__control',
          'ui-field__control--multiline',
          error ? 'ui-field__control--error' : '',
          className ?? '',
        ]
          .filter(Boolean)
          .join(' ')}
        aria-invalid={error ? true : undefined}
        aria-describedby={describedBy || undefined}
        {...rest}
      />
      {hint ? (
        <span id={hintId} className="ui-field__hint">
          {hint}
        </span>
      ) : null}
      <FormError id={errorId} message={error} />
    </div>
  );
}
